import House from './houseTypes/house';
import Apartment_1_room from './houseTypes/apartment_1_room';
import Apartment_2_room from './houseTypes/apartment_2_room';
import Apartment_3_room from './houseTypes/apartment_3_room';
import Apartment_4_room from './houseTypes/apartment_4_room';
import Apartment_5_room from './houseTypes/apartment_5_room';
import Two from './houseTypes/two';
import Townhouse from './houseTypes/townhouse';

const HOUSETYPES = {
  Apartment_1_room,
  Apartment_2_room,
  Apartment_3_room,
  Apartment_4_room,
  Apartment_5_room,
  Two,
  Townhouse,
  House
};

export default HOUSETYPES;